import { extendTheme } from '@chakra-ui/react';

const inputStyle = {
  baseStyle: {
    field: {
      _focus: {
        boxShadow: 'none',
        outline: 'none',
        ring: 'none',
        // borderColor: 'transparent',
      },
      _focusVisible: {
        boxShadow: 'none',
        outline: 'none',
        ring: 'none',
        // borderColor: 'transparent',
      },
      _hover: {
        boxShadow: 'none',
        outline: 'none',
        ring: 'none',
        // borderColor: 'transparent',
      },
      transition: 'none',
    },
  },
  variants: {
    outline: {
      field: {
        // borderColor: 'transparent',
        _hover: {
          // borderColor: 'transparent',
        },
        _focus: {
          // borderColor: 'transparent',
          boxShadow: 'none',
          ring: 'none',
        },
      },
    },
  },
};

export const theme = extendTheme({
  components: {
    Heading: {
      baseStyle: ({ colorMode }) => ({
        color: colorMode === 'light' ? 'gray.700' : 'white',
      }),
    },
    Text: {
      baseStyle: {
        color: 'gray.500',
      },
    },
    Menu: {
      parts: ['menu', 'item', 'group', 'list'],
      baseStyle: ({ colorMode }) => ({
        group: {
          color: 'gray.700',
        },
        item: {
          color: colorMode === 'light' ? 'gray.700' : 'white',
        },
        list: {
          rounded: '2xl',
          color: colorMode === 'light' ? 'gray.700' : 'white',
          bg: colorMode === 'light' ? 'white' : 'gray.800',
        },
      }),
    },
    Modal: {
      parts: ['modal', 'content'],
      baseStyle: () => ({
        content: {
          rounded: '2xl',
        },
      }),
    },
    Button: {
      defaultProps: {
        colorScheme: 'blue',
      },
      baseStyle: {
        rounded: '2xl',
        size: 'md',
      },
    },
    // Removendo o ring dos componentes do Chakra
    // Input: inputStyle,
    // Textarea: inputStyle,
    // Select: inputStyle,
  },
  // Removendo o ring dos componnetes do Chakra
  // Input: inputStyle,
  // Textarea: inputStyle,
  // Select: inputStyle,
  styles: {
    colors: {
      gray: {
        '900': '#181B23',
        '800': '#1F2029',
        '700': '#353645',
        '600': '#4B4D63',
        '500': '#616480',
        '400': '#797D9A',
        '300': '#9699B0',
        '200': '#B3B5C6',
        '100': '#D1D2DC',
        '50': '#EEeEF2',
      },
    },
    global: ({ colorMode }) => ({
      body: {
        fontFamily: 'Roboto',
        color: 'white',
        bg: colorMode === 'light' ? 'gray.100' : 'gray.900',
      },
    }),
  },
});
